import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// ✅ 경로 수정: src 폴더에 있는 campus-lifemain.png를 직접 참조합니다.
import campusMainImg from '../campus-lifemain.png';

function LoginPage() {
  const navigate = useNavigate();
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // ✅ 새로 추가된 알림 모달 상태값 (기존 코드 건드리지 않음)
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isLoginSuccess, setIsLoginSuccess] = useState(false);

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    try {
      const response = await fetch('https://campus-life-production.up.railway.app/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: id, password: password })
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('currentUser', JSON.stringify(data));
        localStorage.setItem('loginTime', Date.now().toString());
        setAlertMessage(`${data.name}님, 환영합니다!`);
        setIsLoginSuccess(true);
        setShowAlertModal(true);
      } else {
        setAlertMessage(data.message || '로그인 실패!');
        setIsLoginSuccess(false);
        setShowAlertModal(true);
      }
    } catch (error) {
      setAlertMessage('서버 연결 실패! 백엔드 서버가 켜져 있는지 확인해 주세요.');
      setIsLoginSuccess(false);
      setShowAlertModal(true);
    }
  };

  const handleAlertConfirm = () => {
    setShowAlertModal(false);
    if (isLoginSuccess) {
      navigate('/main'); // 로그인 성공 시 모달 확인 후 메인으로 이동
    }
  };

  const EyeIcon = () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#95a5a6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
  );
  const EyeOffIcon = () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#95a5a6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
  );

  return (
      <div style={containerStyle}>
        <div style={loginBoxStyle}>
          <div style={imageContainerStyle}>
            {/* ✅ 로고 이미지 크기가 pichuMainStyle에 정의된 대로 커집니다. */}
            <img src={campusMainImg} alt="campus life main" style={pichuMainStyle} />
          </div>
          <h2 style={serviceTitleStyle}>Campus Life Assistant</h2>
          <p style={loginTextStyle}>로그인</p>
          <form style={formStyle} onSubmit={handleLogin}>
            <input
                type="text"
                placeholder="아이디를 입력하세요"
                style={inputStyle}
                value={id}
                onChange={(e) => setId(e.target.value)}
            />
            <div style={passwordWrapperStyle}>
              <input
                  type={showPassword ? "text" : "password"}
                  placeholder="비밀번호를 입력하세요"
                  style={{...inputStyle, marginBottom: 0}}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
              />
              <span onClick={() => setShowPassword(!showPassword)} style={eyeIconStyle}>
              {showPassword ? <EyeOffIcon /> : <EyeIcon />}
            </span>
            </div>
            <button type="submit" style={buttonStyle}>로그인</button>
          </form>
          <div style={footerStyle}>
            <span onClick={() => navigate('/find-pw')} style={linkStyle}>비밀번호 찾기</span>
            <span style={{ margin: '0 10px', color: '#ccc' }}>|</span>
            <span onClick={() => navigate('/register')} style={linkStyle}>회원가입</span>
          </div>
        </div>

        {/* ✅ 새로 추가된 알림 모달 UI */}
        {showAlertModal && (
            <div style={customModalOverlayStyle}>
              <div style={customModalContentStyle}>
                <h3 style={customModalTitleStyle}>{alertMessage}</h3>
                <div style={customModalButtonContainerStyle}>
                  <button
                      style={{ ...customModalConfirmButtonStyle, backgroundColor: '#4A90E2', flex: 'none', padding: '10px 40px' }}
                      onClick={handleAlertConfirm}
                  >
                    확인
                  </button>
                </div>
              </div>
            </div>
        )}
      </div>
  );
}

const containerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f4f7f9', position: 'relative' };
const loginBoxStyle = { backgroundColor: '#ffffff', padding: '40px 40px 60px 40px', borderRadius: '30px', boxShadow: '0 20px 40px rgba(0,0,0,0.06)', textAlign: 'center', width: '380px' };
const imageContainerStyle = { marginBottom: '20px' };
// ✅ 로고 크기를 120px에서 180px로 키웠습니다.
const pichuMainStyle = { width: '180px', height: 'auto' };
const serviceTitleStyle = { fontSize: '20px', fontWeight: '700', color: '#4A90E2', marginBottom: '4px', letterSpacing: '-0.5px' };
const loginTextStyle = { fontSize: '28px', fontWeight: '800', color: '#222', marginBottom: '35px' };
const formStyle = { display: 'flex', flexDirection: 'column', gap: '14px' };
const passwordWrapperStyle = { position: 'relative', display: 'flex', alignItems: 'center' };
const inputStyle = { width: '100%', padding: '16px', borderRadius: '14px', border: '1px solid #eef0f2', backgroundColor: '#f8f9fb', fontSize: '15px', outline: 'none', boxSizing: 'border-box' };
const eyeIconStyle = { position: 'absolute', right: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center' };
const buttonStyle = { padding: '16px', backgroundColor: '#4A90E2', color: 'white', border: 'none', borderRadius: '14px', cursor: 'pointer', fontSize: '17px', fontWeight: '700', marginTop: '10px' };
const footerStyle = { marginTop: '30px', fontSize: '14px', color: '#95a5a6' };
const linkStyle = { cursor: 'pointer', fontWeight: '500' };

// ✅ 모달 전용 스타일 (기존 스타일 맨 밑에 안전하게 추가)
const customModalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 };
const customModalContentStyle = { backgroundColor: '#fff', padding: '30px 40px', borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', textAlign: 'center', minWidth: '320px' };
const customModalTitleStyle = { fontSize: '18px', fontWeight: '600', color: '#333', margin: '0 0 25px 0', whiteSpace: 'pre-line', lineHeight: '1.5' };
const customModalButtonContainerStyle = { display: 'flex', justifyContent: 'center', gap: '12px' };
const customModalConfirmButtonStyle = { padding: '10px 20px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', color: '#fff' };

export default LoginPage;
